import React from 'react'
import { OverflowMenu, OverflowMenuItem } from '../OverflowMenu'
import { updateUserFilteredColumns } from './storeUtils'
import { noop } from 'lodash'

const ColumnsFilterButtonTable = ({
  canSaveFilter = true,
  gridApi,
  identifier, // identifier='wtName'|| pageName
  type, // type='table' || ('pivot' || tableOutput)
  kind, // masterData, scenario, output
  id, // wtId, outputpageId
  userId,
  t,
  linksByUri,
  className = 'overflowFilter bx--btn bx--btn--primary',
  openModal,
  updateUserDataPreferences,
  userPreferences,
  setIsActiveTabular = noop,
  tabular
}) => {
  const onSaveFilteredColumns = (nameFilter, model) => {
    updateUserFilteredColumns(
      {
        tabular,
        activeFilter: gridApi.gridCore.filterManager.getFilterModel(),
        // identifier,
        type,
        model,
        userId,
        nameFilter,
        kind,
        updateUserDataPreferences,
        id
      },
      userPreferences()
    )
  }

  const btnItems = [
    {
      title: 'FilterMenu.SAVE',
      action: () =>
        openModal('saveMyFilters', {
          ...{
            tabular,
            tableApi: gridApi,
            onSave: onSaveFilteredColumns,
            type,
            // identifier,
            t,
            linksByUri,
            userId,
            userPreferences,
            kind,
            updateUserDataPreferences,
            id
          }
        }),
      visible: canSaveFilter
    },
    {
      title: 'FilterMenu.MY_FILTERS',
      action: () =>
        openModal('myFiltersInfo', {
          ...{
            tableApi: gridApi,
            // identifier,
            userId,
            type,
            t,
            linksByUri,
            userPreferences,
            kind,
            updateUserDataPreferences,
            id,
            setIsActiveTabular
          }
        }),
      visible: true
    }
  ]

  return (
    <>
      <OverflowMenu
        renderIcon={() => <div>{t('FilterMenu.TITLE')}</div>}
        // key={`${title}-${i}`}
        /*  menuOffset={{
          left: -1
        }} */
        className={className}
      >
        {btnItems.map(
          ({ title, action, visible }, idx) =>
            visible && (
              <OverflowMenuItem
                key={`${title}-${idx}`}
                onClick={action}
                itemText={t(title)}
              />
            )
        )}
      </OverflowMenu>
    </>
  )
}

export default ColumnsFilterButtonTable
